<template>
  <div>
    <pl-menu direction="right" :menuSize="4" class="z-10 text-xs">
      <button slot="menu_trigger" class="w-8 h-8 hover:bg-coolGray-200 rounded-full">
        <i class="fas fa-ellipsis-v text-sm text-gray-500" />
      </button>
      <ul menu-content>
        <li
          v-if="!hasTeacherPermissionsInCourse && entry.flagged_by"
          class="sample cursor-pointer py-3 px-4 text-xs items-center hover:bg-coolGray-100"
          v-show="entry.flagged_by.includes(getProfile.id)"
          id="flag"
          @click="flagToggle(entry.id)"
        >
          <div class="flex justify-between items-center">
            <span class="mx-3 text-sm">Unflag</span>
            <i class="fa fa-flag" aria-hidden="true"></i>
          </div>
        </li>
        <li
          v-if="!hasTeacherPermissionsInCourse && entry.flagged_by"
          v-show="!entry.flagged_by.includes(getProfile.id)"
          class="sample cursor-pointer py-3 px-4 text-xs hover:bg-coolGray-100"
          id="flag"
          @click="flagClick"
        >
          <div class="flex justify-between items-center text-red-500">
            <span >Flag as inappropriate</span>
            <i class="fa fa-flag " aria-hidden="true"></i>
          </div>
        </li>
        <!-- Unflag comment -->
        <li
          v-if="hasTeacherPermissionsInCourse && entry.is_model_submission"
          class="sample cursor-pointer py-3 px-4 flex justify-between items-center w-full hover:bg-coolGray-100"
          @click="editEntry(entry)"
        >
          <div class="flex justify-between items-center">
            <span class="mx-3 text-sm">Edit</span>
            <i class="fa fa-edit" aria-hidden="true"></i>
          </div>
        </li>
        <li
          v-if="hasTeacherPermissionsInCourse && entry.flagged_by.length"
          id="flag"
          class="sample cursor-pointer py-3 px-4 flex justify-between items-center w-full hover:bg-coolGray-100"
          @click="teacherUnflagComment(entry.id)"
        >
          <div class="flex justify-between items-center">
            <span class="mx-3 text-sm">Unflag Comment</span>
            <i class="fa fa-flag" aria-hidden="true"></i>
          </div>
        </li>
        <!-- Comment Hiding and Reavealing -->
        <li
          v-if="hasTeacherPermissionsInCourse && !entry.is_model_submission"
          class="sample cursor-pointer py-3 px-4 flex justify-between items-center w-full hover:bg-coolGray-100"
          @click="handleCommentClick"
        >
          <template v-if="!entry.is_hidden">
            <div class="flex justify-between items-center">
              <span class="mx-3 text-sm">Hide Comment</span>
              <i class="fas fa-eye-slash" />
            </div>
          </template>
          <template v-else>
            <div class="flex justify-between items-center">
              <span class="mx-3 text-sm">Reveal Comment</span>
              <i class="fas fa-eye" />
            </div>
          </template>
        </li>
        <li
          v-if="hasTeacherPermissionsInCourse"
          class="sample group px-3 py-2 rounded-t flex justify-between items-center w-full h-9 cursor-pointer hover:bg-gray-100"
          @click="deleteEntry(type)"
        >
          <div class="flex justify-between items-center">
            <span class="mx-3 text-sm">Delete</span>
            <i class="text-red-500 fas fa-trash-alt mr-1" />
          </div>
        </li>
      </ul>
    </pl-menu>
    <!-- FLAG DIALOG -->
    <pl-dialog
      v-if="show_flag_dialog"
      @close="show_flag_dialog = false"
      header="Are you sure you would like to flag this?"
    >
      <div class="row end-xs">
        <pl-button class="pl-primary" @click.native="cancelDelete()"
          >CANCEL</pl-button
        >
        <pl-button
          class="pl-primary"
          @click.native="closeDialog('confirm-flag', 'flag')"
          >OK</pl-button
        >
      </div>
    </pl-dialog>

    <!-- DELETE COMMENT -->
    <pl-dialog
      v-if="show_delete_comment_dialog"
      @close="show_delete_comment_dialog = false"
      :maxWidth="'500px'"
      header="Are you sure you want to DELETE this comment?"
    >
      <pl-input
        :labelText="label_confirm_msg"
        :errorMessage="error_message_computed"
        @keyup.native.enter="
          closeDialog('confirm-delete-comment', 'delete-comment')
        "
        v-model="confirm"
      >
      </pl-input>
      <div class="row end-xs">
        <pl-button
          class="pl-primary-font"
          @click.native="show_delete_comment_dialog = false"
          >CANCEL</pl-button
        >
        <pl-button
          class="pl-primary-font"
          @click.native="
            closeDialog('confirm-delete-comment', 'delete-comment')
          "
          >OK</pl-button
        >
      </div>
    </pl-dialog>

    <!-- Comment Hiding Dialog -->
    <!-- Confirmation modal for hiding submission -->
    <pl-confirm
      :typeConfirm="false"
      confirmText="HIDE"
      class="tl"
      v-if="show_hide_comment_modal"
      @confirm="hideComment"
      @close="show_hide_comment_modal = false"
    >
      <div style="width: 90%; margin-left: auto; margin-right: auto">
        <p class="pl-title bold">Hide Comment</p>
        <p>
          This will hide the comment and associated replies from participants in
          the RoundTable. Only you and the original poster can see it from now
          on.
        </p>
        <p>You can undo this at any time.</p>
      </div>
    </pl-confirm>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
  import store from 'store';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        confirm: '',
        error_message: '',
        toast_msg: '',
        label_confirm_msg: 'Type "confirm" into the field to continue',
        show_delete_comment_dialog: false,
        show_flag_dialog: false,
        show_hide_comment_modal: false,
      };
    },
    // type is comment or submission
    props: ['entry', 'type'],
    computed: {
      ...mapGetters([
        'getProfile',
        'hasTeacherPermissionsInCourse',
        'getCurrentRT',
        'summaryOverlayOpened',
      ]),
      error_message_computed() {
        return this.error_message;
      },
    },
    methods: {
      flagClick() {
        if (this.summaryOverlayOpened) {
          this.show_flag_dialog = true;
        } else {
          EventBus.$emit('flagToggle', this.entry, this.type, true);
        }
      },
      flagToggle(entryID) {
        if (this.type === 'comment') {
          roundtableService.flagComment(this.getProfile.id, entryID).then((res) => {
            if (res.data.comment_id === null) {
              store.dispatch('updateCommentFlag', res.data);
            } else {
              store.dispatch('updateReplyFlag', res.data);
            }
            const flagged = res.data.flagged_by.includes(this.getProfile.id);
            const toast_msg = flagged ? 'Flag successful! Your teacher will be notified.' : 'Unflag successful!';
            EventBus.$emit('toast-msg', toast_msg);
          }).catch((err) => {
            const msg = err.response.data.message || 'Something went wrong, please try again.';
            const toast = {type: 'Error', message: msg, time: 5000};
              EventBus.$emit('createToast', toast);
            });
        } else if (this.type === 'submission') {
          roundtableService.flagSubmission(this.getProfile.id, entryID);
        }
      },
      teacherUnflagComment(submissionID) {
        this.$store
          .dispatch('unflagComment', submissionID)
          .then(() => {
            this.show_flag_dialog = false;
          })
          .catch((e) => {
            console.error(e);
            this.show_flag_dialog = false;
          });
      },
      deleteEntry(type) {
        this.error_message = '';
        /* if (this.summaryOverlayOpened) {
          type === 'comment' ? (this.show_delete_comment_dialog = true) : null;
        } else {
          EventBus.$emit('deleteComment', type, this.entry);
          
        } */
        EventBus.$emit('deleteComment', type, this.entry);
      },
      editEntry(entry) {
        EventBus.$emit('edit-model-submission', entry, true);
      },
      closeDialog(ref, action) {
        // finish flagging
        if (action === 'flag') {
          this.flagToggle(this.entry.id);
          this.show_flag_dialog = false;
          return;
        }
        if (action === 'delete-comment' && this.confirm === 'confirm') {
          this.confirm = '';
          this.show_delete_comment_dialog = false; // Close confirm modal

          // The following code modifies the state management (and prevents api call)
          // only if the user is in a sandbox roundtable (interactive demo)
          if (this.getCurrentRT.is_sandbox) {
            store.dispatch('deleteComment', this.entry);
            EventBus.$emit('toast-msg', 'Comment successfully deleted');
            return null; // Return out of handler to prevent regular behaviour
          }

          // DELETE COMMENT service api call
          roundtableService
            .deleteComment(this.entry.id)
            .then(() => {
              EventBus.$emit('toast-msg', 'Comment successfully deleted');
              store.dispatch('updateComment', {
                delete: true,
                id: this.entry.id, // comment to delete
                comment_id: this.entry.comment_id, // if comment is a reply, will have comment_id
                submission_id: this.entry.submission_id,
              });
            })
            .then(() => {
              store.dispatch('deleteComment', this.entry);
              this.entry.is_model_submission
                ? this.$store.dispatch(
                    'toggleModelResponse',
                    this.entry.submission_id
                  )
                : null;
              //EventBus.$emit('modelDeleted');
            })
            .catch(console.error);
        }
        // set error msg with confirm is not filled
        if (action === 'delete-comment' && this.confirm !== 'confirm') {
          this.confirm = '';
          this.error_message =
            'Please type "confirm" in the input box to continue';
          return;
        }
        this.confirm = '';
      },
      cancelDelete() {
        this.show_delete_comment_dialog = false;
        this.error_message = '';
      },
      handleCommentClick() {
        if (this.summaryOverlayOpened) {
          if (this.entry.is_hidden) {
            this.hideComment(false);
          } else {
            EventBus.$emit('handleComment', this.entry);
          }
        } else {
          EventBus.$emit('handleComment', this.entry);
          /* this.show_hide_comment_modal = true; */
        }
      },
      hideComment(hide = true) {
        this.$store.dispatch('toggleHideComment', {
          payload: {
            is_hidden: hide,
          },
          comment_id: this.entry.id,
        });
      },
    },
  };
</script>
<style lang="stylus" scoped>
  #pl-menu li {
    margin: 0 !important
    justify-content: left
  }
</style>



// WEBPACK FOOTER //
// entryOptions.vue?168d5aa0